<script setup lang="ts">
import katex from "katex";

const { t } = useI18n();

const props = withDefaults(defineProps<{ open: boolean; content: string }>(), {
  open: false,
});
const emit = defineEmits(["hide", "submit"]);
const inputRef = ref<HTMLTextAreaElement>();
const content = ref(props.content);

watch(
  () => props.content,
  (value) => {
    content.value = value;
  },
  { immediate: true }
);

const options: katex.KatexOptions = {
  throwOnError: false,
  strict: false,
  displayMode: false,
  maxSize: 300,
  output: "mathml",
};

const renderedPreview = computed(() => {
  if (!content.value) {
    return "";
  }

  return katex.renderToString(content.value, options);
});

const handleOpen = () => {
  nextTick(() => {
    if (inputRef.value) {
      inputRef.value.focus();
    }
  });
};

const handleHide = () => {
  emit("hide");
};

const submit = () => {
  emit("submit", content.value);
};
</script>
<template>
  <teleport to="body">
    <BaseModal :open="open" @show="handleOpen" @hide="handleHide">
      <div class="modal-header">
        <h3 class="modal-title">
          {{ t("headers.latex") }}
        </h3>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body pt-0">
        <BaseTextArea
          ref="inputRef"
          v-model="content"
          rows="3"
          :label="t('labels.latex')"
        />
        <div
          v-safe-html="t('hints.latexSyntax')"
          class="text-end text-muted font-xs"
          style="margin-top: -0.75rem"
        ></div>

        <span class="form-label form-label-md">
          {{ t("labels.preview") }}
        </span>

        <div v-safe-html="renderedPreview" class="katex-editor__preview"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" data-bs-dismiss="modal">
          {{ t("buttons.close") }}
        </button>
        <button class="btn btn-primary" @click="submit">
          {{ t("buttons.save") }}
        </button>
      </div>
    </BaseModal>
  </teleport>
</template>
